export default __webpack_public_path__ + "static/media/logout-icon.4841f33e.svg";